import React from 'react';
import { useTranslatedContent } from '../../i18n/hooks/useTranslatedContent';
import ExpertiseHeader from './header/ExpertiseHeader';
import ExpertiseFeatureGrid from './features/ExpertiseFeatureGrid';

const ExpertiseSection = () => {
  const { t } = useTranslatedContent('expertise');

  return (
    <div id="expertise" className="relative py-24 overflow-hidden">
      {/* Modern gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-indigo-900 to-violet-900">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg width=\'30\' height=\'30\' viewBox=\'0 0 30 30\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Ccircle cx=\'1.22676\' cy=\'1.22676\' r=\'1.22676\' fill=\'rgba(255,255,255,0.1)\'/%3E%3C/svg%3E')] opacity-20" />
      </div>

      {/* Animated light beams */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-1/2 left-1/2 w-[1000px] h-[1000px] bg-gradient-to-b from-violet-500/30 to-transparent rotate-45 transform -translate-x-1/2 animate-pulse" />
        <div className="absolute -bottom-1/2 right-1/2 w-[1000px] h-[1000px] bg-gradient-to-t from-blue-500/30 to-transparent -rotate-45 transform translate-x-1/2 animate-pulse delay-1000" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ExpertiseHeader 
          title={t('title')}
          subtitle={t('subtitle')}
        />
        <div className="mt-20">
          <ExpertiseFeatureGrid />
        </div>
      </div>
    </div>
  );
};

export default ExpertiseSection;